import React from 'react';
import {useTranslation} from "react-i18next";
import {useDish} from "../utils/contexts/dish-context";
import DishNameInput from "../components/CalculateImpact/DishNameInput";
import HistoryOfSearchedDishes from "../components/CalculateImpact/History/HistoryOfSearchedDishes";
import Dish from "../components/CalculateImpact/Dish/Dish";
import NutritionalForm from "../components/CalculateImpact/Dish/Nutritional/NutritionalForm";
import IngredientsWeightForm from "../components/CalculateImpact/Dish/IngredientsWeightForm";
import {useNavigate} from "react-router-dom";
import Button from "../components/UI/Button";
import AiDishDescriptionForm from "../components/CalculateImpact/Dish/AI/AiDishDescriptionForm";
import DishesModal from "../components/CalculateImpact/Dish/AI/DishesModal";
import i18n from "i18next";

const CalculateImpact = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();
    const {dish, weightModalStatus, nutritionalModalStatus, setDish, aiDishDescriptionModalStatus, dishesModalStatus} = useDish();

    const handleGdo = () => {
        setDish(undefined);
        navigate('/gdo');
    }

    const handleTabelog = () => {
        setDish(undefined);
        navigate('/tabelog');
    }

    return (
        <div>
            <div className="p-2 bg-blue-100 relative">
                <div className="absolute top-0 right-0 flex gap-2 items-center justify-center px-2 py-3.5">
                    {i18n.language === 'ja' && (
                        <Button onClick={handleTabelog}>TABELOG</Button>
                    )}
                    <Button onClick={handleGdo}>GDO</Button>
                </div>
                <div className="text-lg font-bold uppercase">{t('calculate_impact.title')}</div>
                <DishNameInput/>
                <HistoryOfSearchedDishes/>
            </div>
            {dish && <Dish/>}
            {dish && weightModalStatus &&
                <IngredientsWeightForm/>
            }
            {dish && nutritionalModalStatus &&
                <NutritionalForm/>
            }
            {dish && aiDishDescriptionModalStatus &&
                <AiDishDescriptionForm/>
            }
            {dish && dishesModalStatus &&
                <DishesModal/>
            }
        </div>
    );
};

export default CalculateImpact;
